import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import SvgIcon from "../../../../parts/SvgIcon";
import { bannerState } from "../../../../utils/email-sending";

const SETTINGS_HREF = "/actions/refresh?modal[type]=sendingSettings";
const TONES = {
  verified: "success",
  none: "info",
  pending: "warning",
  failed: "danger",
  paused: "danger",
};

const BannerText = ({ state, settings, tr }) => {
  if (state === "none") return tr("none");
  if (state === "verified") {
    return (
      <>
        {tr("verified")} <b>{settings.fromName ?? settings.domain}</b>
        {settings.fromEmail ? <b>{` <${settings.fromEmail}>`}</b> : null}
        {" · "}
        {tr("verifiedTail")}
      </>
    );
  }
  return (
    <>
      <strong>{tr(state)}</strong>
      {state === "paused" ? (
        <> · {settings.paused.reason}</>
      ) : (
        <>
          {" · "}
          <b>{settings.domain}</b>
          {" · "}
          {tr(`${state}Tail`)}
        </>
      )}
    </>
  );
};

BannerText.propTypes = {
  state: PropTypes.string.isRequired,
  settings: PropTypes.object.isRequired,
  tr: PropTypes.func.isRequired,
};

// The state of the account's sending domain, above the list of automations
const EmailSendingBanner = ({ settings }) => {
  const { t } = useTranslation("coaching-portal");
  const state = bannerState(settings);
  if (!state) return null;
  if (!state) return null;

  const tr = (key) => t(`emailSending.banner.${key}`);
  return (
    <output className={`es-banner es-banner--${TONES[state]}`}>
      <p>
        <BannerText state={state} settings={settings} tr={tr} />
      </p>
      <a href={SETTINGS_HREF}>
        {state === "verified" ? (
          <SvgIcon
            src="/img/new-icons/settings.svg"
            useCurrentColor
            classNames="icon-sm"
          />
        ) : null}
        <span>
          {tr(`${state}Cta`)}
          {state === "verified" ? "" : " →"}
        </span>
      </a>
    </output>
  );
};

EmailSendingBanner.propTypes = {
  settings: PropTypes.shape({
    state: PropTypes.string,
    domain: PropTypes.string,
    fromName: PropTypes.string,
    fromEmail: PropTypes.string,
    paused: PropTypes.shape({ reason: PropTypes.string }),
  }),
};

export default EmailSendingBanner;
